import { defineComponent } from 'vue';
import { BApp } from 'bootstrap-vue-next';
import Ribbon from '@/core/ribbon/ribbon.vue';
import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';
import LoginForm from '@/account/login-form/login-form.vue';

import { emitter } from '@/shared/event-bus';

import '@/shared/config/dayjs';

export default defineComponent({
  components: {
    ribbon: Ribbon,
    'jhi-navbar': JhiNavbar,
    'login-form': LoginForm,
    'jhi-footer': JhiFooter,
    BApp,
  },
  data() {
    return {
      loginShown: false,
    };
  },
  mounted(): void {
    // Login modal piloté par l'event-bus (remplace $root.$emit('bv::show|hide::modal'))
    emitter.on('show-login', this.showLogin);
    emitter.on('hide-login', this.hideLogin);
  },
  unmounted(): void {
    emitter.off('show-login', this.showLogin);
    emitter.off('hide-login', this.hideLogin);
  },
  methods: {
    showLogin(): void {
      this.loginShown = true;
    },
    hideLogin(): void {
      this.loginShown = false;
    },
  },
});
